import React, { useState } from "react";
import { X } from "lucide-react";
import ImageUploader from "@/components/ImageUploader";

const VideoModal = ({ video, seasons, token, onClose, onSave }) => {
  const [formData, setFormData] = useState({
    title: video?.title || '',
    season_id: video?.season_id || '',
    season_year: video?.season_year || '',
    date: video?.date || '',
    description: video?.description || '',
    thumbnail: video?.thumbnail || '',
    video_url: video?.video_url || '',
    duration: video?.duration || '',
    opponent: video?.opponent || '',
    video_type: video?.video_type || 'game',
    category: video?.category || 'basketball'
  });
  
  const handleSeasonChange = (seasonId) => {
    const season = seasons.find(s => s.id === seasonId);
    setFormData({
      ...formData,
      season_id: seasonId,
      season_year: season?.year || ''
    });
  };
  
  const handleSubmit = (e) => {
    e.preventDefault();
    onSave(formData);
  };
  
  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2 className="modal-title">{video ? 'Edit Video' : 'Add Video'}</h2>
          <button className="modal-close" onClick={onClose}>
            <X size={20} />
          </button>
        </div>
        
        <form onSubmit={handleSubmit}>
          <div className="modal-body">
            <div className="form-group">
              <label className="form-label">Title *</label>
              <input
                type="text"
                className="form-input"
                value={formData.title}
                onChange={(e) => setFormData({ ...formData, title: e.target.value })}
                placeholder="e.g., Kentucky vs Louisville"
                required
                data-testid="video-title-input"
              />
            </div>
            
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem' }}>
              <div className="form-group">
                <label className="form-label">Season</label>
                <select
                  className="form-select"
                  value={formData.season_id}
                  onChange={(e) => handleSeasonChange(e.target.value)}
                  data-testid="video-season-select"
                >
                  <option value="">None (TBT/Football)</option>
                  {seasons.map((s) => (
                    <option key={s.id} value={s.id}>{s.year}</option>
                  ))}
                </select>
              </div>
              
              <div className="form-group">
                <label className="form-label">Category *</label>
                <select
                  className="form-select"
                  value={formData.category}
                  onChange={(e) => setFormData({ ...formData, category: e.target.value })}
                  data-testid="video-category-select"
                >
                  <option value="basketball">Basketball</option>
                  <option value="tbt">TBT</option>
                  <option value="football">Football</option>
                </select>
              </div>
            </div>

            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem' }}>
              <div className="form-group">
                <label className="form-label">Type *</label>
                <select
                  className="form-select"
                  value={formData.video_type}
                  onChange={(e) => setFormData({ ...formData, video_type: e.target.value })}
                  data-testid="video-type-select"
                >
                  <option value="game">Game</option>
                  <option value="documentary">Documentary</option>
                </select>
              </div>

              <div className="form-group">
                <label className="form-label">Opponent</label>
                <input
                  type="text"
                  className="form-input"
                  value={formData.opponent}
                  onChange={(e) => setFormData({ ...formData, opponent: e.target.value })}
                  placeholder="e.g., Louisville"
                />
              </div>
            </div>
            
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem' }}>
              <div className="form-group">
                <label className="form-label">Date *</label>
                <input
                  type="text"
                  className="form-input"
                  value={formData.date}
                  onChange={(e) => setFormData({ ...formData, date: e.target.value })}
                  placeholder="e.g., Dec 21, 2023"
                  required
                  data-testid="video-date-input"
                />
              </div>
              
              <div className="form-group">
                <label className="form-label">Duration</label>
                <input
                  type="text"
                  className="form-input"
                  value={formData.duration}
                  onChange={(e) => setFormData({ ...formData, duration: e.target.value })}
                  placeholder="e.g., 2:15:30"
                />
              </div>
            </div>
            
            <div className="form-group">
              <label className="form-label">Video URL (ok.ru) *</label>
              <input
                type="text"
                className="form-input"
                value={formData.video_url}
                onChange={(e) => setFormData({ ...formData, video_url: e.target.value })}
                placeholder="https://ok.ru/video/..."
                required
                data-testid="video-url-input"
              />
            </div>
            
            <ImageUploader
              value={formData.thumbnail}
              onChange={(url) => setFormData({ ...formData, thumbnail: url })}
              token={token}
              label="Thumbnail"
            />
            
            <div className="form-group">
              <label className="form-label">Description</label>
              <textarea
                className="form-textarea"
                value={formData.description}
                onChange={(e) => setFormData({ ...formData, description: e.target.value })}
                placeholder="Video description..."
              />
            </div>
          </div>
          
          <div className="modal-footer">
            <button type="button" className="btn btn-secondary" onClick={onClose}>
              Cancel
            </button>
            <button type="submit" className="btn btn-primary" data-testid="save-video-btn">
              {video ? 'Update' : 'Create'} Video
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default VideoModal;
